<template lang="html">
  <v-content class="content-wrapper">
    <v-layout class="mb-2" align-center style="flex: 0;">
      <h1 class="mr-3">Review & Export</h1>
      <sx-button-group :is-joined="true">
        <div @click="reviewAndExportTab = 0">
          <sx-button
            type="secondary"
            :is-left="true"
            :is-active="reviewAndExportTab === 0"
          >
            Review
          </sx-button>
        </div>
        <div @click="reviewAndExportTab = 1">
          <sx-button
            type="secondary"
            :is-right="true"
            :is-active="reviewAndExportTab === 1"
          >
            Export
          </sx-button>
        </div>
      </sx-button-group>
      <v-spacer />
      <sc-button-group>
        <v-layout align-center shrink>
          <div class="text-xs-left mr-2">Year</div>
          <v-select
            v-model="selectedYear"
            :items="yearOptions"
            hide-details
            class="default-input body-1"
            solo
            small
            style="max-width: 120px"
          />
        </v-layout>
        <sc-button
          @click="triggerRefreshInReviewAndExportForEntity()"
          type="ghost"
          icon-left="refresh"
          :is-icon-only="true"
          :with-bottom-tooltip="true"
          >Refresh</sc-button
        >
        <sc-button
          @click="downloadLeadsheet(currentCompany)"
          type="primary"
          icon-left="download"
          :with-tooltip="true"
          >Leadsheet</sc-button
        >
      </sc-button-group>
    </v-layout>
    <v-card class="review-export-card">
      <v-card-text>
        <ReviewAndExportForEntity
          v-if="currentCompany"
          :selected-entity="currentCompany"
          :selected-year="selectedYear"
          :show-leadsheet.sync="showLeadsheet"
          :zoom="zoom"
          :review-and-export-tab.sync="reviewAndExportTab"
          ref="reviewAndExportForEntity"
        />
      </v-card-text>
    </v-card>
  </v-content>
</template>

<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import ReviewAndExportForEntity from '@/components/ReviewAndExportForEntity.vue';
import DataEntryMixin from '@/mixins/DataEntryMixin';
import { yearOptions } from '@/constants/variables';
import SxFlex from '@/components/sx/SxFlex';
import SxIcon from '@/components/sx/SxIcon';
import SxSmall from '@/components/sx/SxSmall';
import SxButton from '@/components/sx/SxButton';
import SxButtonGroup from '@/components/sx/SxButtonGroup';

export default {
  name: 'ReviewAndExportPage',
  components: {
    ReviewAndExportForEntity,
    SxFlex,
    SxIcon,
    SxSmall,
    SxButton,
    SxButtonGroup,
  },
  mixins: [DataEntryMixin],
  data() {
    return {
      yearOptions,
      showLeadsheet: true,
      selectedYear: 2024,
      zoom: false,
      currentCompany: null,
      reviewAndExportTab: 0,
      currentCompanyId: null,
    };
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      isFirmCommunicationDisabled: 'isFirmCommunicationDisabled',
      isFirmDocumentsDisabled: 'isFirmDocumentsDisabled',
      currentUser: 'user',
      isAdvisor: 'isAdvisor',
      defaultCompany: 'defaultCompany',
    }),
    ...mapGetters(['currentFirm']),
  },
  methods: {
    moment,
    isEmpty,
    triggerRefreshInReviewAndExportForEntity() {
      var reviewAndExportForEntity = this.$refs.reviewAndExportForEntity;
      reviewAndExportForEntity.getAllExportableDocumentsForEntity();
    },
  },
  async created() {
    const { hash } = this.$route.params;
    const hashId =
      hash && hash !== 'undefined' && hash.substring(hash.lastIndexOf('-') + 1);
    if (this.$route.query.companyId) {
      this.currentCompanyId = parseInt(this.$route.query.companyId);
    } else if (hashId) {
      try {
        const { data } = await API.company.getCompanyIdByHashId(hashId);
        this.currentCompanyId = data.id;
      } catch (error) {
        this.$router.push('/select-entity');
      }
    } else {
      this.currentCompanyId = this.defaultCompany.id;
    }

    try {
      const response = await API.company.getCompany(this.currentCompanyId);
      this.currentCompany = response.data;

      await this.$store.dispatch('resetTiles', {
        hashId: this.currentCompany.hash_id,
        clientName: this.currentCompany.name
          .replaceAll(' ', '-')
          .replaceAll(',', ''),
      });
    } catch (e) {
      console.error(e);
      this.$router.push('/select-entity');
    }
    this.triggerRefreshInReviewAndExportForEntity();
  },
  watch: {
    reviewAndExportTab: {
      handler(tab) {
        if (tab === 0) {
          this.showLeadsheet = true;
        } else {
          this.showLeadsheet = false;
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped>
.content-wrapper {
  /* 64px is the height of the top bar, 72px is the vertical padding (36px for each) and 16px for the margin? */
  height: calc(100vh - 64px - 72px - 16px);
}

.content-wrapper {
  & >>> .v-content__wrap {
    display: flex;
    flex-direction: column;
  }
}

.review-export-card {
  display: flex;
  flex-direction: column;
  flex: auto;
  min-height: 0;

  & >>> .v-card__text {
    display: flex;
    flex-direction: column;
    flex: auto;
    min-height: 0;
  }
}

.documents {
  &__icon {
    font-size: 18px;
  }
}
.document-action {
  &__icon {
    font-size: 20px;
  }
}
.documents-row {
  &__updated-date {
    font-weight: 200;
    color: rgba(9, 30, 66, 0.6);
  }
}
.image-holder {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.breadcrumbs {
  & >>> .clickable {
    cursor: pointer;
    color: #777;
  }
  & >>> .clickable:hover {
    color: #000;
  }
}

.documents-folder--empty {
  color: var(--gray-500);
}

.documents-folder--empty > span:first-child:after {
  padding-left: 6px;

  color: var(--gray-200);

  content: ' (Empty)';
  font-style: italic;
}
</style>
